module.exports = __webpack_public_path__ + "static/media/profile-icon-gray.2d8b78d8.svg";